const Footer = () => (
  <div style={{ textAlign: "center", color: "#999", fontSize: "0.8em" }}>
    © {new Date().getFullYear()} American Corporate Partners.
  </div>
);

export default Footer;
